import { TextField } from '@mui/material';

interface Props {
    value: number | null | undefined;
    disabled?: boolean;
    onChange: (rowCount: number | undefined) => void;
}

export default function TableRowCountField({ value, disabled = false, onChange }: Props) {
    return (
        <TextField
            label="Number of rows (optional)"
            type="number"
            disabled={disabled}
            value={value ?? ''}
            helperText="Leave blank to let clients add as many rows as they need"
            inputProps={{ min: 1, step: 1 }}
            onChange={(event) => {
                const raw = event.target.value;
                if (raw === '') {
                    onChange(undefined);
                    return;
                }

                const parsed = Number.parseInt(raw, 10);
                if (Number.isNaN(parsed) || parsed < 1) {
                    return;
                }

                onChange(parsed);
            }}
        />
    );
}
